import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PlanCoverWrapper = styled.div`
    display: flex;
    padding: 20px;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid #e7e7f0;
    border-radius: 12px;
`;

export const PlanCoverTitle = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 12px;
    line-height: 22px;
    color: #040222;
    margin-bottom: 20px;
`;

export const CoverDetailsWrapper = styled.div`
    display: flex;
`;

export const IconFlex = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`;

export const TitleFlex = styled.div`
    display: flex;
    flex-direction: column;
    flex: 3;
    justify-content: center;
`;

export const Title = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    color: #040222;
`;

export const SubTitle = styled.div`
    display: flex;
    margin-top: 6px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #5b5675;
`;

export const Hr = styled.div`
    width: 100%;
    height: 0px;
    border: 1px solid rgba(91, 86, 117, 0.1);
    margin: 15px 0;
`;

export const Hr1 = styled.div`
    width: 100%;
    height: 0px;
    border: 1px solid rgba(91, 86, 117, 0.1);
    margin: 8px 0;
`;

export const MoreReason = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #5b5675;
    margin-top: 24px;
    margin-bottom: 20px;
`;

export const MoreReasonFlex = styled.div`
    display: flex;
`;

export const MoreReasonIconFlex = styled.div`
    display: flex;
    align-items: center;
`;

export const MoreReasonText = styled.div`
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #040222;
    margin-left: 10px;
`;
